import { z } from "zod"
import { TranslationKey } from "../i18n/translation-key"

export enum MaterialType {
  SLANG = "SLANG",
  BROMSBELAGG = "BROMSBELAGG",
  BROMSKLOSSAR = "BROMSKLOSSAR",
  VAXELVAJER = "VAXELVAJER",
  BROMSVAJER = "BROMSVAJER",
}

export const DefaultMaterialPriceSchema = z.object({
  id: z.string(),
  materialType: z.nativeEnum(MaterialType),
  price: z.number().min(0),
  storeId: z.string(),
  createdAt: z.date(),
  updatedAt: z.date(),
})

export const UpdateDefaultMaterialPriceSchema = z.object({
  materialType: z.nativeEnum(MaterialType),
  price: z.number().min(0),
})

export const UpdateDefaultMaterialPricesSchema = z.object({
  prices: z.array(UpdateDefaultMaterialPriceSchema),
})

export type DefaultMaterialPrice = z.infer<typeof DefaultMaterialPriceSchema>
export type UpdateDefaultMaterialPrice = z.infer<
  typeof UpdateDefaultMaterialPriceSchema
>
export type UpdateDefaultMaterialPrices = z.infer<
  typeof UpdateDefaultMaterialPricesSchema
>

export const MATERIAL_TYPE_LABEL_KEYS: Record<MaterialType, TranslationKey> = {
  [MaterialType.SLANG]: "common.materialType.innerTube",
  [MaterialType.BROMSBELAGG]: "common.materialType.brakePads",
  [MaterialType.BROMSKLOSSAR]: "common.materialType.brakeBlocks",
  [MaterialType.VAXELVAJER]: "common.materialType.gearCable",
  [MaterialType.BROMSVAJER]: "common.materialType.brakeCable",
}

// Part IDs mapping for each material type
export const MATERIAL_PART_IDS: Record<MaterialType, string[]> = {
  [MaterialType.SLANG]: [
    "e98d047c-4989-4ada-a291-b18238cb90cc", // framslang
    "01657704-9287-42ee-a89a-f7c7452e5584", // bakslang
  ],
  [MaterialType.BROMSBELAGG]: [
    "3cbfe4b3-339d-4a79-8f2a-c0d028f1d7a9", // bromsbelägg fram
    "128d9da2-2e6c-49b7-9684-1d52b727c01a", // bromsbelägg bak
  ],
  [MaterialType.BROMSKLOSSAR]: [
    "9468fe4f-de35-4e2c-9389-f3f8194456f0", // bromsklossar fram
    "a6f1297b-7a11-48ea-92be-6517bdbbf13f", // bromsklossar bak
  ],
  [MaterialType.VAXELVAJER]: [
    "bbdb4195-67eb-42eb-af10-7e93e48158c4", // växelvajer fram
    "9faffbe3-4a49-40c6-96a2-3f9275a66b71", // växelvajer bak
  ],
  [MaterialType.BROMSVAJER]: [
    "1e1861be-1b3a-43fe-9ae4-8e9dacc55515", // bromsvajer fram
    "cc195f82-3971-46e4-b1da-c70e6c53b87e", // bromsvajer bak
  ],
}
